import React from 'react';

import { Table } from 'antd';

import { showDateNoTime } from '@libs/NwMoment';
import { getMoment } from '@libs/NwMoment';

import VerticalDate from '@components/Dates/VerticalDate';
import Money from '@components/Gui/Money';
import TransactionEvent from '@components/Transactions/TransactionEvent';
import TransactionTitle from '@components/Transactions/TransactionTitle';

const ContractCreationDrawerTransactionItem = ({ modelID, onSelect, project, transactions }) => {
    const TransactionRefDate = ({ transaction }) => {
        if (transaction.RefDate && !transaction.WorkDate) {
            if (getMoment(transaction.RefDate).year() > 1900) {
                return <p className="upper">{showDateNoTime(transaction.RefDate)}</p>;
            }
        }
        return null;
    };

    // {transaction.ConfirmationProperties &&
    //     <div>
    //         {(transaction.ConfirmationProperties.Confirmed !== null) &&
    //             <p>confirmed: {String(transaction.ConfirmationProperties.Confirmed)}</p>
    //         }
    //         {transaction.ConfirmationProperties.OptionNumber &&
    //             <p>option number: {transaction.ConfirmationProperties.OptionNumber}</p>
    //         }
    //         {(transaction.ConfirmationProperties.Cancel !== null) &&
    //             <p>cancel: {String(transaction.ConfirmationProperties.Cancel)}</p>
    //         }
    //     </div>
    // }

    const transactionColumns = [
        {
            title: 'Date',
            key: 'Date',
            render: (record) => {
                return (
                    <div className="transaction-date">
                        <VerticalDate date={record.WorkDate} />
                    </div>
                );
            },
        },
        {
            title: 'Title',
            key: 'Title',
            width: '100%',
            render: (record) => {
                return (
                    <div className="transaction-text">
                        <TransactionTitle transaction={record} />
                        <TransactionEvent transaction={record} project={project} />
                        {/* <TransactionRefDate transaction={record} /> */}
                    </div>
                );
            },
        },
        {
            title: 'Amount',
            key: 'Amount',
            align: 'right',
            render: (record) => {
                return (
                    <div className="transaction-amount">
                        <div className="transaction-fee">
                            <div className="total-fee">
                                <Money highlightCurrency amount={record.TotalFee} currency={record.Currency} />
                            </div>
                        </div>
                    </div>
                );
            },
        },
    ];

    const onSelectChange = (newSelectedRowKeys) => {
        onSelect(newSelectedRowKeys, modelID);
    };

    const getActiveTransactionKeys = () => {
        return transactions.filter((transaction) => transaction.active).map((transaction) => transaction.key);
    };

    const rowSelection = {
        selectedRowKeys: getActiveTransactionKeys(),
        onChange: onSelectChange,
    };

    return (
        <Table
            rowSelection={rowSelection}
            showHeader={false}
            pagination={false}
            columns={transactionColumns}
            size="small"
            dataSource={transactions.map((transaction) => ({
                ...transaction,
                key: transaction.ID,
                WorkDate: transaction.WorkDate,
                ModelID: transaction.ModelID,
            }))}
        />
    );
};

export default ContractCreationDrawerTransactionItem;
